import {FC, useContext, useEffect, useState} from 'react'
import {isEmpty} from '../../common/Helpers'
import ActiveFilterItem from './ActiveFilterItem'
import {useTranslation} from 'react-i18next'
import {GlobalContext} from '../../common/ctx/GlobalContext'

const ActiveFilters: FC<{
    ctx: any
    filters: object
}> = ({ctx, filters}) => {
    const {t} = useTranslation()
    const globalCtx = useContext(GlobalContext)
    const [localFilters, setLocalFilters] = useState<Record<string, any>>({})

    const handleDefault = (): void => {
        ctx.setDefault()
    }

    useEffect(() => {
        setLocalFilters(() => {
            const filtered = Object.entries(ctx.activeFilters).filter(([key]) => key !== 'name')
            return Object.fromEntries(filtered)
        })
    }, [ctx.activeFilters])

    return (
        <>
            {globalCtx.layout === 'fio' && !isEmpty(filters) && isEmpty(localFilters) && (
                <section className="active-filters-list">
                    <div className="delete flex">
                        <div className="delete-all flex">
                            <span onClick={handleDefault}>{t('label.filters.clean')} </span>
                        </div>
                    </div>
                </section>
            )}

            {!isEmpty(localFilters) && !isEmpty(filters) && (
                <section className="active-filters-list">
                    <div className="section-active-filters flex">
                        <span>{t('label.filters.active')}</span>
                    </div>

                    <div className="border-filters flex">
                        {Object.entries(localFilters).map(([key, value]) => {
                            if (Array.isArray(value)) {
                                return value.map((item, index) => {
                                    if (key === 'products') key = 'product' //fix for products/product
                                    if (key === 'umbrellas') key = 'umbrella' //fix for umbrellas/umbrella
                                    if (!filters[key]) {
                                        return (
                                            <div key={`noFilter${key}${item}`}>
                                                <strong>
                                                    {key} {item}
                                                </strong>
                                            </div>
                                        )
                                    }
                                    const filterItem = filters[key].find((filter) => filter.value === item)
                                    return (
                                        <ActiveFilterItem
                                            key={`selectedFilter${key}${item}${index}`}
                                            label={filterItem ? t(filterItem.label) : key + ' ' + item}
                                            value={item}
                                            html_for={key + '_' + item}
                                        />
                                    )
                                })
                            } else {
                                return (
                                    <ActiveFilterItem
                                        key={`selectedFilter${key}${value}`}
                                        label={t('label.' + key + '.title')}
                                        value={value}
                                        html_for={key + '_' + value}
                                    />
                                )
                            }
                        })}
                    </div>
                    {globalCtx.layout === 'fio' &&
                    Object.entries(localFilters).length === 1 &&
                    localFilters.unitCategory?.length === 1 &&
                    localFilters.unitCategory?.includes('A') ? (
                        <></>
                    ) : (
                        <div className="delete flex">
                            <div className="delete-all flex">
                                <span onClick={handleDefault}>{t('label.filters.clean')} </span>
                            </div>
                        </div>
                    )}
                </section>
            )}
        </>
    )
}

export default ActiveFilters
